import { Theme } from '@mui/material';
import { createStyles } from "@mui/styles";

//////////////////////////////////////////////////////////////////////////////////////

export const othersStyles = (theme: Theme) => createStyles({
    listRoot: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 300,
    }
});

export interface IOtherListProps {
    groupId: string;
    onClose: (id?: string) => void;
}

export interface IOtherProps {
    groupId: string;
    anchor: any;
    onClose: () => void;
}

export interface IOtherState {
    list: Array<any>;
}
